/* eslint-disable */

import React from 'react';
import {NavLink, Link} from 'react-router-dom';
import menuItems, {menuItemsEN} from '../../config/sideBarMenu';
import logo from '../../assets/logo.svg';
import se from '../../assets/SE.svg'
import us from '../../assets/UK.svg'
import { setLangState, langState, categorySetState } from '../../state/activities';
import {useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { CategorySetType } from '../../utils/categoryConfig';

const activeClass = 'flex items-center gap-3 text-white px-5 py-3 text-[14px] font-semibold transition-colors duration-150';
const inactiveClass = 'flex items-center gap-3 text-gray-menu px-5 py-3 text-[14px] font-normal hover:text-gray-200 transition-colors duration-150';

const getIconSrc = (icon: any) => typeof icon === 'object' && icon.default ? icon.default : icon;

const renderMenuItems = (items: any[], activeClass: string, inactiveClass: string) =>
  items.map((el) => {
    const isExternalLink = /^https?:\/\//.test(el.link);
    if (isExternalLink) {
      return (
        <a
          href={el.link}
          className="flex items-center justify-center gap-2 mx-4 mt-3 px-4 py-2.5 rounded-lg text-[12px] font-semibold text-white bg-main-blue hover:bg-main-blue/90 shadow-md shadow-main-blue/30 transition-all duration-150"
          key={el.id}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          {el.name}
        </a>
      );
    }
    return (
      <NavLink
        to={el.link}
        className={(navData) => navData.isActive ? activeClass : inactiveClass}
        key={el.id}
        children={(navData) => (
          <>
            <span className="w-5 h-5 flex-shrink-0 opacity-75">
              <img src={getIconSrc(navData.isActive ? el.iconActive : el.icon)} alt="" className="w-full h-full" />
            </span>
            {el.name}
          </>
        )}
      />
    );
  });

const AppSideBarMenu = () => {
  const setLang = useSetRecoilState(setLangState);
  const lang = useRecoilValue(langState);
  const [categorySet, setCategorySet] = useRecoilState(categorySetState);

  return (
    <div className="flex flex-col justify-between h-full w-full">
      {/* Logo */}
      <div>
        <div className="px-5 pt-5 pb-6">
          <img src={logo} alt="LOGO" className="h-7" />
        </div>

        {/* Nav */}
        {renderMenuItems(
          lang === 'SV' ? menuItems : menuItemsEN,
          activeClass,
          inactiveClass,
        )}
      </div>

      {/* Bottom controls */}
      <div className="px-4 pb-5 space-y-3">
        <div className="border-t border-white/[0.08] mb-2" />

        {/* Category set */}
        <div>
          <div className="text-[10px] uppercase tracking-[0.1em] text-gray-400 mb-1.5 px-1">
            {lang === 'EN' ? 'Category set' : 'Kategoriset'}
          </div>
          <div className="flex bg-white/[0.08] rounded-lg p-[3px]">
            <button
              onClick={() => setCategorySet('default' as CategorySetType)}
              className={`flex-1 text-[11px] font-semibold py-2 rounded-md transition-all duration-200 ${
                categorySet === 'default'
                  ? 'bg-main-blue text-white shadow-md shadow-main-blue/30'
                  : 'text-gray-400 hover:text-white hover:bg-white/[0.06]'
              }`}
            >
              Standard
            </button>
            <button
              onClick={() => setCategorySet('hvb' as CategorySetType)}
              className={`flex-1 text-[11px] font-semibold py-2 rounded-md transition-all duration-200 ${
                categorySet === 'hvb'
                  ? 'bg-main-blue text-white shadow-md shadow-main-blue/30'
                  : 'text-gray-400 hover:text-white hover:bg-white/[0.06]'
              }`}
            >
              HVB
            </button>
          </div>
        </div>

        {/* Language */}
        <div>
          <div className="text-[10px] uppercase tracking-[0.1em] text-gray-400 mb-1.5 px-1">
            {lang === 'EN' ? 'Language' : 'Språk'}
          </div>
          <div className="flex bg-white/[0.08] rounded-lg p-[3px]">
            <button
              onClick={() => setLang('SV')}
              className={`flex-1 flex items-center justify-center gap-1.5 text-[11px] font-semibold py-2 rounded-md transition-all duration-200 ${
                lang === 'SV'
                  ? 'bg-main-blue text-white shadow-md shadow-main-blue/30'
                  : 'text-gray-400 hover:text-white hover:bg-white/[0.06]'
              }`}
            >
              <img src={se} alt="SV" className="w-4 h-3 object-cover rounded-[2px]" />
              SV
            </button>
            <button
              onClick={() => setLang('EN')}
              className={`flex-1 flex items-center justify-center gap-1.5 text-[11px] font-semibold py-2 rounded-md transition-all duration-200 ${
                lang === 'EN'
                  ? 'bg-main-blue text-white shadow-md shadow-main-blue/30'
                  : 'text-gray-400 hover:text-white hover:bg-white/[0.06]'
              }`}
            >
              <img src={us} alt="EN" className="w-4 h-3 object-cover rounded-[2px]" />
              EN
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSideBarMenu;
